module.exports = __webpack_public_path__ + "Assets/Images/font-pairings/watch.jpg";